import {Data, Int, RecordProps} from '@store/@types/util';
import {UserId} from 'records/User';
import {Moment} from 'moment/moment';
import moment from 'moment';

export enum FileDirection {
  INBOUND = 'inbound',
  SCREENSHARE = 'screenshare',
  OUTBOUND = 'outbound',
  INTERNAL = 'internal',
  UNKNOWN = 'unknown',
}

interface CrmEntity {
  id: Int;
  name: string;
}

export type LiveCoachingCallId = string;
interface LiveCoachingCallInterface {
  id: LiveCoachingCallId;
  callerId: UserId;
  dateTime: Moment;

  direction?: FileDirection;
  phoneCountryCode?: string;
  phoneNumber?: string;
  phoneExtension?: string;
  crmAccount?: CrmEntity;
  crmContact?: CrmEntity;
  crmOpportunity?: CrmEntity;
}

/**
 * Represents a live coaching call, similar to our usual FileUpload,
 * will evolve as we build this out
 */
export default class LiveCoachingCall extends Data<LiveCoachingCallInterface>({
  id: undefined,
  callerId: undefined,
  direction: undefined,
  phoneCountryCode: undefined,
  phoneNumber: undefined,
  phoneExtension: undefined,
  dateTime: undefined,
  crmAccount: undefined,
  crmContact: undefined,
  crmOpportunity: undefined,
}) {
  constructor(props: RecordProps<LiveCoachingCallInterface>) {
    super({
      ...props,
      id: props.id,
      callerId: props.callerId,
      dateTime: props.dateTime ?? moment(),
    });
  }
}
